import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import api, { setToken, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Authenticate from the secure httpOnly cookie (no token read from localStorage).
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setToken(data.token); // in-memory header for this session; cookie is the source of truth
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout failed:", apiError(e));
    }
    setToken(null);
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, login, logout, loading }), [user, login, logout, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
